var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVitaNottura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.00125 19.85999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.63016,19.86h-.23a.2151.2151,0,0,0,.11-.02h.01A.215.215,0,0,0,7.63016,19.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.52018,19.84h-.01a.2151.2151,0,0,1-.11.02h.23A.215.215,0,0,1,7.52018,19.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95017,6.16a.85929.85929,0,0,0-.18-.2.65006.65006,0,0,0-.13-.04.58481.58481,0,0,0-.13-.02H.52018a.48919.48919,0,0,0-.44.26.471.471,0,0,0-.01.51l2.27,4.27.04.08,3.71,6.99v1.33a.51642.51642,0,0,0,.52.52h.79a.2151.2151,0,0,0,.11-.02h.01a.215.215,0,0,0,.11.02h.79a.51642.51642,0,0,0,.52-.52V18.01l2.86-5.39.5-.94.35-.66.04-.08.35-.66,1.04-1.95.23-.41.5-.96.15-.29A.471.471,0,0,0,14.95017,6.16Zm-1.3.79-.01.01-.5.93a.74262.74262,0,0,1-.07.12l-1.17,2.2h-8.77l-1.75-3.27h12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52018,19.84h-.01a.2151.2151,0,0,1-.11.02h.23A.215.215,0,0,1,7.52018,19.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.99124,6.34a6.38874,6.38874,0,0,0-1.88-4.45V1.88a6.43537,6.43537,0,0,0-4.44-1.87A.41178.41178,0,0,0,13.56125,0a.3417.3417,0,0,0-.1.01,6.36642,6.36642,0,0,0-4.34,1.79.90126.90126,0,0,0-.1.09l-.07.07c-.01.01-.02.03-.03.04a.00976.00976,0,0,0-.01.00995,6.35572,6.35572,0,0,0-1.59,2.85h1.08a5.32961,5.32961,0,0,1,1-1.84l1.85,1.84h1.45l-2.57-2.57a5.24015,5.24015,0,0,1,2.91-1.23v3.8h1.04V1.07a5.31723,5.31723,0,0,1,2.92,1.21l-2.59,2.58h.1a1.30654,1.30654,0,0,1,.38.06,1.76717,1.76717,0,0,1,.34.12l.08.03.06.05a1.48374,1.48374,0,0,1,.13.11l2.23-2.23a5.32147,5.32147,0,0,1,1.2,2.92h-2.94a1.4339,1.4339,0,0,1-.02,1.04h2.96a5.23272,5.23272,0,0,1-1.2,2.92l-2.15-2.15-.36.68-.14.27,1.92,1.92a5.2456,5.2456,0,0,1-2.92,1.21V10.53l-.12.24-.35.63-.05.11-.35.66-.35.67a5.36954,5.36954,0,0,0,.7.04.40979.40979,0,0,0,.11-.01,6.42143,6.42143,0,0,0,6.32-6.32.41.41,0,0,0,.01-.11A.30815.30815,0,0,0,19.99124,6.34Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.67816,
    y1: 6.93976,
    x2: 13.66777,
    y2: 6.95014
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.47122,4.86h-1.11l-.82-2.21-.17,1.1a.51551.51551,0,1,1-1.02-.15l.46-3.09A.52005.52005,0,0,1,2.27127.07a.51293.51293,0,0,1,.54.34Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVitaNottura);
export default __webpack_public_path__ + "static/media/iconVitaNottura.6dd5d87229b1c4b288a7caeff77d9c19.svg";
export { ForwardRef as ReactComponent };